<script>
  import { createEventDispatcher, onDestroy } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Input from '@components/Input.svelte';
  import Notification from '@utils/notification';
  import Profile from '@utils/profile';

  import EmojiPicker from '@app-components/EmojiPicker.svelte';
  import EmojiButton from '@app-components/EmojiButton.svelte';

  import { getProfileStore } from '@stores/profile';
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let groupCollectionSortOrderStore = getProfileStore('groupCollectionSortOrderStore');

  import GroupCollectionAjax from '@ajax/group_collection';
  import UserAjax from '@ajax/user';
  import { getCurrentUserStore } from '@stores/current_user';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile = false;
  export let collectionId;

  let collection = collectionId ? groupCollectionStore.find(collectionId) : undefined;

  let unsub = collection ? collection.subscribe((x) => (collection = x)) : () => {};

  let user = getCurrentUserStore('default');
  let saving = false;
  let name = collection && collection.name;

  let selectedEmoji;
  let imageSource = (collection && collection.emoji && collection.emoji.outside_src) || '/images/save-button/star.png';

  let showEmojiPicker = false;

  var close = function (collectionId) {
    dispatch('close', { collectionId: collectionId });

    showModal = false;
    saving = false;
    name = '';
    selectedEmoji = undefined;
  };

  let submitOnEnter = function (e) {
    if (e.detail.which == 13) {
      saveCollection();
    }
  };

  let saveCollection = function () {
    if (collection) {
      updateCollection();
    } else {
      addCollection();
    }
  };

  let updateCollection = async function () {
    saving = true;

    try {
      let data = { name: name };

      if (selectedEmoji) {
        data['emoji_id'] = selectedEmoji.id;
        data['emoji'] = selectedEmoji;
      }

      let resp = await GroupCollectionAjax.update(collection, data);
      collection.set({ ...collection, ...data });
      dispatch('updated-collection', { collection: resp });
      return close(resp.id);
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }

    saving = false;
  };

  let addCollection = async function () {
    saving = true;

    try {
      let resp = await GroupCollectionAjax.create({
        name: name,
        emoji_id: selectedEmoji && selectedEmoji.id,
      });

      let ids = [...Profile.collectionSortOrderByPageIds(), resp.id];
      groupCollectionSortOrderStore.set(ids);
      groupCollectionStore.add(resp);

      UserAjax.update(user, {
        group_collection_sort_order: ids,
      });

      dispatch('added-collection', { collection: resp });
      return close(resp.id);
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }

    saving = false;
  };

  onDestroy(() => {
    unsub();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 20px;
    text-align: center;
  }

  .ui-cancel {
    font-weight: 500;
    color: black;
  }

  .form-input-group {
    margin-bottom: 16px;
  }

  .add-section-link {
    font-size: 15px;
    opacity: 0.5;
    font-weight: 500;
    line-height: 15px;
    color: #000;

    &:hover {
      opacity: 1;
    }
  }

  label {
    font-size: 13px;
    line-height: 15px;
    opacity: 0.5;
    margin-bottom: 12px;
    font-weight: normal;
  }

  .ui-actions {
    margin-top: 40px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;

    .add-section-btn {
      height: 48px;
      color: white;
      font-weight: 500;
      font-size: 14px;
      border: none;
      border-radius: 15px;
      background: #a893f9;
      width: 275px;

      &:hover {
        background: #7054dc;
      }
    }

    .cancel-btn {
      width: 100%;
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }

  * :global(.emoji-picker) {
    position: unset !important;
    width: calc(100% + 15px) !important;
  }
</style>

<Modal
  mobile={mobile}
  on:close={close}
  show={showModal}
  showCloseButton={false}
  fadeInDuration={200}
  style="border-radius: 16px; width: 490px">
  <div slot="content">
    <div class="ui-header">{collection ? 'Edit' : 'Add'} Collection</div>

    <div
      style="margin-top: 50px; width: 275px; margin-left: auto; margin-right:
      auto;">
      <div style="margin-bottom: 40px;">
        <EmojiButton
          mobile={true}
          imageSource={imageSource}
          on:click={() => {
            showEmojiPicker = true;
          }} />

        {#if showEmojiPicker}
          <div style="z-index: 2; margin-left: -15px;">
            <EmojiPicker
              mobile={mobile}
              on:emoji-selected={(e) => {
                showEmojiPicker = false;
                selectedEmoji = e.detail.emoji;
                imageSource = e.detail.emoji.outside_src;
              }} />
          </div>
        {/if}
      </div>

      <Input
        focus={true}
        bind:value={name}
        label="Collection Name"
        labelStyle="font-size: 15px"
        inputStyle="font-size: 17px; font-weight: normal"
        placeholder=""
        on:keyup={submitOnEnter} />
    </div>

    <div class="ui-actions">
      <button class="add-section-btn" on:click|preventDefault={saveCollection}>
        {#if saving}
          <div>
            <i class="fa fa-spin fa-spinner" />
            <span style="margin-left: 10px;">{collection ? 'Editing' : 'Adding'} collection</span>
          </div>
        {:else}{collection ? 'Edit' : 'Add'} Collection{/if}
      </button>
      <button class="cancel-btn" on:click|preventDefault={close}>Cancel</button>
    </div>
  </div>
</Modal>
